// Mirror of CommonPdfDiplomasSection.jsx: per diploma, a 16% / 84% row.
// Left = school + date range; right = education level (accent) + diploma title.

import { TableRow, VerticalAlign } from "docx";
import { formatDate } from "../../../../utils/formatDate";
import { cell, dividerRule, frac, layoutTable, para, run } from "../../shared/wordHelpers";
import { FONT_ARIAL } from "../../shared/wordTheme";
import { pxToTwips } from "../../shared/wordUnits";

export function buildCommonDiplomas( { data, props, translations, accent } ) {
    const { diplomas } = data;
    const { documentLanguage, isAnonymous } = props;
    const t = translations?.pdf ?? {};

    const leftW = frac( 0.16 );
    const rightW = frac( 0.84 );

    const elements = [];

    diplomas
        .filter( diploma => diploma.from && ( diploma.to || diploma.isCurrent ) )
        .sort( ( a, b ) => a.order - b.order )
        .forEach( ( diploma, index ) => {
            if ( index > 0 ) {
                elements.push( dividerRule( accent ) );
            }

            const left = [
                para( run( isAnonymous ? t.diplomasSchoolLabel : diploma.schoolName, { pt: 8, bold: true, font: FONT_ARIAL } ), { spacing: { after: 0 } } ),
                para( run(
                    `${ formatDate( diploma.from, documentLanguage ) } - ${ diploma.isCurrent ? t.isCurrentLabel : formatDate( diploma.to, documentLanguage ) }`,
                    { pt: 8, font: FONT_ARIAL }
                ), { spacing: { after: 0 } } ),
            ];

            const right = [];
            const level = diploma.educationLevel?.translations?.[ documentLanguage ];
            if ( level ) {
                right.push( para( run( level, { pt: 8, color: accent, font: FONT_ARIAL } ), { spacing: { after: 0 } } ) );
            }
            right.push( para( run( diploma.diplomaTitle, { pt: 8, font: FONT_ARIAL } ), { spacing: { after: 0 } } ) );

            elements.push( layoutTable(
                [
                    new TableRow( {
                        children: [
                            cell( left, { widthTwips: leftW, valign: VerticalAlign.TOP } ),
                            cell( right, {
                                widthTwips: rightW,
                                valign: VerticalAlign.TOP,
                                margins: { left: pxToTwips( 6 ), top: 0, bottom: 0, right: 0 },
                            } ),
                        ],
                    } ),
                ],
                { columnWidths: [ leftW, rightW ] }
            ) );
        } );

    return elements;
}
